<template>
  <div class="my-8 p-4 pt-2 mr-28 shadow-md border-primary border-l-8 pl-4">
    <h2 class="text-gray-800 mb-2">
      {{ verdict.title }}
    </h2>
    <div v-if="verdict.score > 0 && verdict.options?.isScoreEssential !== false" class="text-sm">
      Score : {{ verdict.score }}
    </div>
    <ul class="flex flex-col gap-1.5 text-gray-800">
      <li v-for="(line, index) in lines" :key="index" class="flex items-start gap-2.5">
        <StatusDot v-if="line.state" :state="line.state" class="mt-2" />
        <span v-else class="mt-2 h-2 w-2 shrink-0 rounded-full bg-primary/40" />
        <span>{{ line.text }}</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import {computed} from "vue";
import {SurveyVerdict} from "@/core/interfaces/survey/Survey";
import StatusDot from "@/core/components/ui/badge/StatusDot.vue";
import {statusDotEmojis} from "@/core/components/ui/badge/statusDot";

const props = defineProps<{
    verdict: SurveyVerdict;
}>();

const leadingEmoji = new RegExp(`^\\s*(${Object.keys(statusDotEmojis).join('|')})\\s*`, 'u');

/**
 * The verdict lines, each one carrying the state its leading marker emoji
 * stands for, when the API gave one.
 */
const lines = computed(() => props.verdict.description
    .split('\n')
    .filter(line => line.trim() !== '')
    .map(line => {
        const match = line.match(leadingEmoji);

        return {
            text: match ? line.slice(match[0].length) : line,
            state: match ? statusDotEmojis[match[1]] : undefined,
        };
    }));
</script>
